var $1e8678632c464b6d$exports = {};
$1e8678632c464b6d$exports = {
  "Empty": "\u0386\u03B4\u03B5\u03B9\u03BF"
};
export { $1e8678632c464b6d$exports as default };